import React from 'react';
import { Button, CircularProgress } from '@material-ui/core';
import RefreshIcon from '@material-ui/icons/Refresh';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  '@global': {
    '@keyframes dashboardRefreshSpin': {
      '0%': {
        transform: 'rotate(0deg)'
      },
      '100%': {
        transform: 'rotate(360deg)'
      }
    }
  },
  button: {
    minWidth: 100
  },
  icon: {
    animation: (props) => props.loading ? 'dashboardRefreshSpin 1s linear infinite' : 'none'
  }
}));

const RefreshButton = ({ onRefresh, loading = false }) => {
  const classes = useStyles({ loading });
  
  return (
    <Button
      variant="outlined"
      color="primary"
      onClick={onRefresh}
      disabled={loading}
      startIcon={loading ? <CircularProgress size={20} /> : <RefreshIcon className={classes.icon} />}
      className={classes.button}
    >
      {loading ? 'Refreshing...' : 'Refresh'}
    </Button>
  );
};

export default RefreshButton;
